import type { Transaction } from '@shared/transactions-types';
import type { EnvironmentConfig } from '@luna/env';
import { getEnv } from '@luna/env';
import { createQuery, request } from '@luna/api';
import { isFeatureEnabled } from '@luna/gatekeeper';

import type {
    OrderLinkRequestItem,
    OrderLinksResponse,
    TransactionWithOrderReference,
} from './types';

export const [useOrderLinks] = createQuery({
    name: '@transactions/orders-links',
    cacheKey: (transactions) => transactions.map(({ id }) => id).join('-'),
    payloadCreator: async (transactions: Transaction[]) => {
        const isFetchingPaymentOrderLinksEnabled = isFeatureEnabled(
            (features) => features.transactions.paymentOrderLink,
        );
        if (!isFetchingPaymentOrderLinksEnabled) {
            return [];
        }
        const items = getOrderLinkRequestItems(transactions);
        const { localApiBaseUrl } = getEnv<EnvironmentConfig>();
        const url = `${localApiBaseUrl}my/orders/payments/bulk-transaction-links`;
        const { transactionOrderLinks } = await request.post<OrderLinksResponse>(url, { items });
        return transactionOrderLinks;
    },
});

function getOrderLinkRequestItems(transactions: Transaction[]): OrderLinkRequestItem[] {
    return transactions
        .filter((transaction): transaction is TransactionWithOrderReference => {
            return Boolean(transaction.collectiveOrderReference);
        })
        .map(({ id, collectiveOrderReference }) => ({
            transactionId: id,
            paymentInfo: collectiveOrderReference,
        }));
}
